export type GetDataKindRequest = {
  dfnSetVerNum?: string;
};
